module.exports = __webpack_public_path__ + "media/images/icons/icon_close_gray-5a78c8344deda304005fc8df5311ca9b.svg";